import { faFacebook, faTwitter } from '@fortawesome/free-brands-svg-icons'
import { faAddressCard, faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

function Contacts() {
  return (
    <div className='mt-2'>
        <div className='jumbotron text-center bg-light border'>
            <FontAwesomeIcon icon={faAddressCard} fontSize={128} className='mb-5 text-danger'/>
            <h2>Contact Us</h2>
            <p>Let's turn your ideas into reality. Contact us to get started.</p>
        </div>
        <div className='container'>
            <div className='row'>
                <div className='col-lg-4'>
                    <div className='card bg-light p-3'>
                        <FontAwesomeIcon icon={faFacebook} fontSize={64} className="card-img-top m-2 text-danger"/>
                        <div className='card-body text-center'>
                            <a className="App-link" target="_blank" rel="noopener noreferrer" href="https://facebook.com/MileSoft.Co">/MileSoft.Co</a>
                        </div>
                    </div>
                </div>
                <div className='col-lg-4'>
                    <div className='card bg-light p-3'>
                        <FontAwesomeIcon icon={faTwitter} fontSize={64} className="card-img-top m-2 text-danger"/>
                        <div className='card-body text-center'>
                            <a className="App-link" target="_blank" rel="noopener noreferrer" href="https://twitter.com/MileSoftCo">@MileSoftCo</a>
                        </div>
                    </div>
                </div>
                <div className='col-lg-4'>
                    <div className='card bg-light p-3'>
                        <FontAwesomeIcon icon={faEnvelope} fontSize={64} className="card-img-top m-2 text-danger"/>
                        <div className='card-body text-center'>
                            <a className="App-link" target="_blank" rel="noopener noreferrer" href="mailto:MileSoft.Co@gmail.com">MileSoft.Co@gmail.com</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className='container'>&nbsp;</div>
    </div>
  )
}

export default Contacts